// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import factoryIcon from "@/assets/icons/aop/factory.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FactoryIconProps = Omit<IconProps, "name">;

export function FactoryIcon(props: FactoryIconProps): React.ReactNode {
  return <Icon name={factoryIcon} {...props} />;
}
